import { render, staticRenderFns } from "./GalleryEdit.vue?vue&type=template&id=aa9b3926&"
import script from "./GalleryEdit.vue?vue&type=script&lang=js&"
export * from "./GalleryEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports